import React from 'react'
import { useDragDropContext } from './DragDropContext'

interface DroppableProps {
  droppableId: string
  children: (props: { isDraggingOver: boolean; dropIndex: number | null }) => React.ReactNode
}

export function Droppable({ droppableId, children }: DroppableProps) {
  const { dragState } = useDragDropContext()
  const isDraggingOver = dragState.isDragging && dragState.currentDropZone === droppableId
  const dropIndex = isDraggingOver ? dragState.currentDropIndex : null

  return (
    <div data-droppable-id={droppableId} style={{ position: 'relative', width: '100%' }}>
      {children({ isDraggingOver, dropIndex })}
    </div>
  )
}
